<template>
  <table width="100%">
    <tr>
      <!-- <td>
              <img class="m-auto" src="static/assets/img/icon-signal1.png" />
            </td> -->
      <td>
        <p>
          <small class="time-stamp float-right">{{signal.Date | formatDate('MM/DD/YYYY hh:mm a')}}</small>
          <strong>{{signal.SignalType}}</strong>
        </p>
        <p>
          <strong>Customer opened a campaign email</strong>
        </p>
        <p>Campaign:
          <strong>{{signal.CampaignName}}</strong>
        </p>
      </td>
      <td></td>
    </tr>
  </table>
</template>

<script>
  import moment from 'moment';
  export default {
    props: ['signal'],
    filters: {
      formatDate: function (value, momentFormat) {
        if (!value) return ''
        return moment(String(value)).format(momentFormat)
      }
    }
  }

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/CustomerProfile/Signals/SignallTypes/ImOpen.vue